import React from "react";
import ProductCard from "../Product/ProductCard";

const MoreItems = ({ products, title }) => {
  return (
    <div className="mb-10">
      <h4 className="mb-5 mt-10 font-pop text-2xl font-medium uppercase text-darkGreen">
        {title || "More Items"}
      </h4>
      <div className="grid grid-cols-5 justify-items-center gap-y-4">
        {new Array(5).fill(0).map((_, index) => (
          <ProductCard key={index} product={products[index % 5]} />
        ))}
      </div>
    </div>
  );
};

export default MoreItems;
